import actions from '../../../actions';
import { changeConsent } from '../../../actions/consents';
import { getConsentData } from '../../../agreementsConfig';
import {
    Page,
    React
} from '../../../common';
import {
    ChildModalAgreements,
    ModalAgreements
} from '../../../common/Modal';
import api from '../../../services/api';
import { parseToDdMmYyyy } from '../../../utils';

export const checkConsentReceived = async ({
    consents: {
        consents,
        providerCode,
    } = {},
    profileId,
    dispatch,
    clinics,
    loadingDelay = 1000,
}) => {
    return new Promise((resolve) => {
        dispatch(changeConsent({
            providerCode,
            loadingDelay,
            profileId,
            consent: consents,
            onCancel: (...params) => {
                console.log('Consent cancel', params);
                resolve({ received: true });
            },
            onComplete: (...params) => {
                console.log('Consent complete', params);
                resolve({ received: true });
            },
            onError: (e, provider, consent) => {
                const cons = getConsentData(Object.keys(consent)?.[0], provider);
                console.log('!!! onError', cons);
                resolve({
                    received: false,
                    error: {
                        level: 'error',
                        message: Object.R('errors.ErrorSetClinicConsent', {
                            consent: cons?.textWithoutPrefix ?? '',
                            clinic: clinics?.[provider]?.name ?? provider,
                        }),
                    },
                });
            },
        }));
        console.log(`Consents fo set: ${providerCode}`, consents);
    });
};

export const checkConsentReceivedOld = (info, profile) => {
    return new Promise((resolve) => {
        if (info?.me?.consentReceived && (!profile?.isChild || profile?.consentReceived)) {
            resolve(true);
            return;
        }

        const childModal = () =>
            Page.showModal(
                <ChildModalAgreements
                    title={[
                        profile?.fullNameRu ?? profile?.firstLastName ?? '', parseToDdMmYyyy(profile?.birthday) ?? '',
                    ].join(', ')}
                    centerTitle={true}
                    onCancel={() => {
                        Page.closeModal();
                        resolve(false);
                    }}
                    onConfirm={() => {
                        Page.closeModal();
                        api.updateChild({
                            _id: profile?.profileId,
                            consentReceived: true,
                        })
                            .then(() => {
                                resolve(true);
                                setTimeout(
                                    () =>
                                        actions.reloadUserInfo(
                                            Object.handleNewUserItemsFound,
                                            actions.updatePrefs,
                                            actions.updateSelects,
                                        ),
                                    100,
                                );
                            })
                            .catch(() => {
                                resolve(false);
                            });
                    }}
                />,
            );
        !info?.me?.consentReceived
            ? Page.showModal(
                <ModalAgreements
                    onConfirm={() => {
                        Page.closeModal();
                        api.updateUserInfo({ consentReceived: true });
                        if (profile?.relKind === 'CHILD') {
                            setTimeout(() => {
                                childModal();
                            }, 500);
                        } else {
                            setTimeout(
                                () =>
                                    actions.reloadUserInfo(
                                        Object.handleNewUserItemsFound,
                                        actions.updatePrefs,
                                        actions.updateSelects,
                                    ),
                                100,
                            );
                            resolve(true);
                        }
                    }}
                    onCancel={() => {
                        Page.closeModal();
                        resolve(false);
                    }}
                    title={[ info?.name ?? '', parseToDdMmYyyy(info?.birthday) ?? '' ]
                        ?.filter?.((i) => i)
                        ?.join
                        ?.(', ')}
                    centerTitle={true}
                />,
            )
            : childModal();
    });
};
